import {BaseModel} from "./base-model";

export class Metadata extends BaseModel {

  protected static self = Metadata;

  url : string;
  duration : number;
  size : number;
  contentType: string;
  recStart: number;
  recEnd: number;

  public validate(): boolean {
    return true;
  }
}
